// extracted by mini-css-extract-plugin
module.exports = {"messageInfo":"InfoMessage_messageInfo__3O_fX","closeButton":"InfoMessage_closeButton__3qCnI"};